import React, {useState} from 'react'
const App = () => {
    const [data, setData] = useState({
      username: "",
      email:'',
      password:'',
      ConfirmPassword:""
   
    })
    const {username, email, password, ConfirmPassword} = data;
    const changeHandler = e => {
      setData({...data, [e.target.name]:e.target.value})
      }
      const submitHandler = e => {
        e.preventDefault();
        if(username.length <= 5 ){
          alert("user name must be at least 5 character")
                  }
           
                 else if(password !== ConfirmPassword){
                    alert('passwords are not matching')
                  }
                  else{
                    console.log(data)
                    }
        }
  return(
    <div>
      <center>
      <form onSubmit ={submitHandler}>
<label>User Name: </label><input type="text" size="30" placeholder="Username" name ="username" onChange={changeHandler} value={username}/><br/>
<label>Email:     <input type="email" size="36" name = "email" placeholder="Email" onChange={changeHandler} value={email}/></label><br/>
<label>Password: <input type="password" size="32" name="password" placeholder="Password" onChange={changeHandler} value={password}/></label><br/>
<label>Confirm Password: <input type="password" size="23" name="ConfirmPassword" placeholder="Confirm Password" onChange={changeHandler} value={ConfirmPassword}/></label><br/>
<br/>
<input type="submit" name ="submit"/>
</form>
      </center>
    </div>
  )
}
export default App;
 
 
 
